module.exports = __webpack_public_path__ + "static/media/two-col-selector.a33db1df.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/two-col-selector.md
// module id = 406
// module chunks = 0